import React, { useContext } from "react";
import { IconButton, Badge } from "@mui/material";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import { useLocation } from "react-router-dom";
import { CartContext } from "../../context/CartContext";
import { useCart } from "../../context/CartContext";

const CartIconButton = () => {
  const { cartItems } = useContext(CartContext);
  const { setShowCartPreview } = useCart();
  const location = useLocation();

  const isOnCartPage = location.pathname === "/cart";

  const cartItemCount = cartItems.reduce(
    (total, item) => total + item.quantity,
    0
  );

  return (
    <IconButton
      onClick={!isOnCartPage ? () => setShowCartPreview(true) : undefined}
      color="default"
      disabled={isOnCartPage}>
      <Badge
        badgeContent={cartItemCount > 9 ? "+9" : cartItemCount}
        color="primary"
        sx={{
          "& .MuiBadge-badge": {
            right: -3,
            top: 3,
            fontSize: "0.7rem",
            fontWeight: "bold",
            borderRadius: "50%",
            minWidth: 18,
            height: 18,
          },
        }}>
        <ShoppingBagIcon />
      </Badge>
    </IconButton>
  );
};

export default CartIconButton;
